module.exports = __webpack_public_path__ + "static/img/par.c7bba1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/par.png
// module id = Ii08
// module chunks = 11